module.exports = __webpack_public_path__ + "img/banner-2.8a08510c.jpg";